import React from "react";
import { cn, mapEdgesToNodes } from "../../../lib/helpers";
import { graphql, useStaticQuery } from "gatsby";
import { CardCta } from "../../card/card";
import { pageDocPath } from "../../../../helpers";
import { ImageBuilder } from "../../global/image-builder";

const STORY_CTA_TEXT = "Read the story";

const query = graphql`
  query CustomerStoriesQuery {
    docs: allSanityStory(
      sort: { fields: [orderRank], order: ASC }
      filter: {
        slug: { current: { ne: null } }
        status: { eq: "published" }
        statistics: { elemMatch: { number: { ne: null } } }
      }
    ) {
      edges {
        node {
          ...cardNodeStory
        }
      }
    }
  }
`;

// stats tiles
export const CustomerStories = ({ section }) => {
  const data = useStaticQuery(query) || {};
  const docs = mapEdgesToNodes(data.docs).slice(0, section.cards || 4);

  return docs.length > 0 ? (
    <ul
      className={cn(
        "grid gap-2 p-2 bg-white border border-dark-20 rounded-xl",
        section.cards && section.cards % 3 === 0
          ? "sm:grid-cols-3"
          : "sm:grid-cols-2 lg:grid-cols-4"
      )}
    >
      {docs.map((doc, i) => (
        <li key={i}>
          <a
            href={pageDocPath(doc)}
            className={[
              `block h-full relative bg-dark-2 hover:bg-dark-5 focus:bg-dark-10 transition-colors`,
              `border border-dark-10 rounded-lg p-3 pb-6 pt-2 md:p-4 md:pb-6 md:pt-2`,
            ].join(" ")}
          >
            <ImageBuilder
              image={doc?.company?.mainImage}
              quality={100}
              height={60}
              style={{
                maxHeight: "60px",
              }}
            />
            <div className="text-6xl md:text-9xl font-light leading-none tracking-tight mt-1 mb-2">
              {doc.statistics[0].number}
            </div>
            <div>{doc.statistics[0].suffix}</div>
            <CardCta text={STORY_CTA_TEXT} />
          </a>
        </li>
      ))}
    </ul>
  ) : null;
};
